import axios from "axios";
import qs from "qs";
import { Message, Loading } from "element-ui";
import router from "../router";
import bus from "../../src/views/common/bus.js"
import { getToken, clearToken } from "../utils/auth";


// 运行时可配置：window.APP_CONFIG.apiBase 或 window.API_BASE
function resolveApiBase() {
  if (window.APP_CONFIG && typeof window.APP_CONFIG.apiBase === 'string') {
    return window.APP_CONFIG.apiBase;
  }
  if (typeof window.API_BASE === 'string') {
    return window.API_BASE;
  }
  return '';
}

let loading;
const Axios = axios.create({
  baseURL: resolveApiBase(),
  timeout: 100000,
  responseType: "json",
  withCredentials: false, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  }
});

//POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某件事
    if (config.method === "post") {
      if (!config.hideLoading) {
        loading = Loading.service({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      }

      if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=utf-8') {
        // 序列化
        config.data = qs.stringify(config.data);
      }
    }
    let token = getToken();
    if (token !== null && token !== undefined) {
      config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
  },
  error => {
    Message({
      //  饿了么的消息弹窗组件,类似toast
      showClose: true,
      message: error,
      type: "error.data.error.message"
    });
    return Promise.reject(error.data.error.message);
  }
);

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    loading && loading.close();
    let data = res.data;
    // console.log(data, 'data');
    // console.log(data.status, 'data');
    // console.log(res.data.status, 'a');
    let success = data.status === 0 || data.code === 0
    if (data.status === 10) {
      clearToken()
      router.push("/login")
      return
    }
    let msg = data.msg;
    //对响应数据做些事
    if (!success) {
      Message({
        //  饿了么的消息弹窗组件,类似toast
        showClose: true,
        message: msg,
        type: "error"
      });
      return Promise.reject(res.data);
    }
    return Promise.resolve(res.data);
  },
  error => {
    loading && loading.close();
    console.log(error, 'error----');
    Message({
      showClose: true,
      message: "内部错误,请联系平台开发人员",
      type: "error"
    });

    return Promise.reject(error);
  }
);
export {
  Axios
}
// 对axios的实例重新封装成一个plugin ,方便 Vue.use(xxxx)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, "$api", { value: Axios });
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js